export const serverPath = "https://prong-flash-cookie.glitch.me/";
